module.exports = __webpack_public_path__ + "img/tik_tok.3b4bf9c3.webp";